import React from 'react';

export default class Middle extends React.Component
{
    render()
    {
        return <div className="flex w-full">
            <div className="m-auto">
                {this.props.children}
            </div>
        </div>;
    }
}
